import { Gate } from '@grammarly/experimentation-js-sdk'

export const Gates = {
  // GDPR Inverted - if a user is NOT GDPR, this gate is 'enabled', otherwise we assume the user is GDPR
  GDPRInverted: new Gate('gdpr_inverted'),

  // USA geolocation. determined by country code = 'us'. this gate is for privacy compliance check purpose
  USA: new Gate('geo_usa'),

  // Privacy regulation by Transcend airgap.js scripts
  AirGap: new Gate('airgap'),

  // Privacy regulation by Transcend airgap.js scripts for footer link
  AirGapFooter: new Gate('airgap_footer'),

  // Use OneTrust Test script.
  OneTrustTest: new Gate('onetrust_test'),

  // Disable OneTrust  script.
  OneTrustDisabled: new Gate('onetrust_disabled'),

  // DATA-2383 Marketing email hold back
  MarketingEmailHoldBack: new Gate('marketing_email_hold_back'),

  // DATA-2476 Complementary gate to marketing email hold back
  MarketingEmailControl: new Gate('marketing_email_control'),

  // GSF-2993 Enable FullStory
  FullStoryTracking: new Gate('full_story_tracking'),

  PageLogFeMetrics: new Gate('page_log_fe_metrics'),
}

export const StatsigGates = {
  WhatsNewHeaderItem_25: new Gate('whats_new_header_item_25'),
  UpdateOpeningsPageUrls_25: new Gate('update_openings_page_urls_25'),
  // G2A-1381 Signup Dynamic Banner on AI Detector + Paraphrasing Tool
  DynamicBannerV2: new Gate('dynamic_banner_v2'),
  SobcWorkweekWithAi_25: new Gate('sobc_workweek_with_ai25'),
  WebVitalsTracking: new Gate('web_vitals_tracking'),
  CompanyAnnouncement6_25: new Gate('company_announcement_6_25'),
  WebHeartbeatTracking: new Gate('web_heartbeat_tracking'),
  LocalizedPlansIndiaAnon: new Gate('vito_localized_prices_india_homepage_anon'),
  SprigTracking: new Gate('sprig_tracking'),
}
const strictGates: { [key: string]: Gate } = { ...Gates, ...StatsigGates }

export const GatesSet: Set<string> = new Set(Object.values(strictGates).map((gate) => gate.name))
